.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.label {
  font: var(--hs-type-label);
  letter-spacing: var(--hs-label-ls);
  color: var(--hs-color-text-primary);
}
.input {
  width: 100%;
  height: var(--hs-field-height);
  padding: 0 var(--hs-spacing-4);
  border: 1px solid var(--hs-color-border-default);
  border-radius: var(--hs-radius-md);
  background: var(--hs-color-bg-surface);
  color: var(--hs-color-text-primary);
  font: var(--hs-type-body);
  transition:
    border-color 120ms ease,
    box-shadow 120ms ease;
}
.input::placeholder {
  color: var(--hs-color-text-tertiary);
  opacity: 1;
}
.input:hover:not(:disabled) {
  border-color: var(--hs-color-border-strong);
}
.input:focus-visible {
  outline: none;
  border-color: var(--hs-color-primary-default);
  box-shadow: var(--hs-focus-lavender);
}
.input:disabled {
  background: var(--hs-color-bg-muted);
  opacity: 0.6;
  cursor: not-allowed;
}
.hint {
  margin: 0;
  font: var(--hs-type-body-s);
  color: var(--hs-color-text-secondary);
}

/* A password: the field, and at its end the button that shows what was typed. */
.control {
  position: relative;
}
.withButton {
  padding-right: calc(var(--hs-field-height) + var(--hs-spacing-1));
}
.reveal {
  position: absolute;
  top: 50%;
  right: var(--hs-spacing-1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: var(--hs-radius-full);
  background: transparent;
  color: var(--hs-color-text-secondary);
  cursor: pointer;
  transform: translateY(-50%);
}
.reveal:hover:not(:disabled) {
  background: var(--hs-color-bg-subtle);
  color: var(--hs-color-text-primary);
}
.reveal:focus-visible {
  outline: none;
  box-shadow: var(--hs-focus-lavender);
}
.reveal:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* What is typed is wrong: the border says so, and the field is marked for assistive technology. */
.invalid,
.invalid:hover:not(:disabled) {
  border-color: var(--hs-color-danger-default);
}
/* The field's name for assistive technology only, where the layout says it otherwise
   (a language's code beside a translation). */
.hiddenLabel {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
